import { SvgIconProps } from "../types";

export const PngIcon = ({ src, width, height }: SvgIconProps) => (
  <img src={`/img/png/${src}`} alt={src} width={width} height={height} />
);
